import { render, staticRenderFns } from "./RxRole.vue?vue&type=template&id=00f03c5a"
import script from "./RxRole.vue?vue&type=script&lang=js"
export * from "./RxRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports